/* External */
import { memo, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withFocusable } from '@noriginmedia/react-spatial-navigation';

/* Components */
import ScrollView from '../ScrollView';

/* Utils */
import { useOnBackPress } from '../../utils/keyDownEvents';
import { PageType } from '../../utils/constants';

function getFocusableItemInMain() {
  const focusableItemInMain = sessionStorage.getItem('focusableItemInMain');
  if (focusableItemInMain) {
    sessionStorage.removeItem('focusableItemInMain');
    return focusableItemInMain;
  }
  return undefined;
}

function Main({
  className,
  openSidebar,
  children,
  isSidebarExpanded,
  pageId,
  initialScrollPosition,
  hasFocusedChild,
  setFocus,
  isModalShown,
}) {
  const handleScroll = useCallback((offset) => {
    if (
      pageId === PageType.LIVE || pageId === PageType.SPORTS
    ) {
      sessionStorage.setItem('offsetFromStartedPage', offset);
    }
  }, [pageId]);

  useOnBackPress({ listener: openSidebar, when: !isSidebarExpanded });

  useEffect(() => {
    if (!isSidebarExpanded && !hasFocusedChild && !isModalShown) {
      setFocus(getFocusableItemInMain());
    }
  }, [isSidebarExpanded, hasFocusedChild, setFocus, isModalShown]);

  return (
    <ScrollView
      className={className}
      initialScrollPosition={initialScrollPosition}
      onScroll={handleScroll}
    >
      {children}
    </ScrollView>
  );
}

Main.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  openSidebar: PropTypes.func.isRequired,
  isSidebarExpanded: PropTypes.bool,
  pageId: PropTypes.string,
  initialScrollPosition: PropTypes.number,
  hasFocusedChild: PropTypes.bool.isRequired,
  setFocus: PropTypes.func.isRequired,
  isModalShown: PropTypes.bool.isRequired,
};

Main.defaultProps = {
  className: '',
  children: [],
  isSidebarExpanded: false,
  pageId: undefined,
  initialScrollPosition: 0,
};

export default memo(withFocusable({ trackChildren: true })(memo(Main)));
